import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function RouteButton({ to, variant, className, ...props }) {
	return <Link to={to} className={`btn btn-${variant} ${className}`} {...props} />;
}

RouteButton.defaultProps = {
	variant: 'secondary',
	className: ''
};

RouteButton.propTypes = {
	/**
	 * url path to link to
	 */
	to: PropTypes.string.isRequired,

	/**
	 * button variant
	 */
	variant: PropTypes.string,

	/**
	 * additional classes
	 */
	className: PropTypes.string,

	/**
	 * visible content of the link
	 */
	children: PropTypes.node.isRequired
};
